import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";

const SCRIPT = "https://checkout.razorpay.com/v1/checkout.js";

function loadScript() {
  if (window.Razorpay) return Promise.resolve();
  return new Promise((resolve, reject) => {
    const s = document.createElement("script");
    s.src = SCRIPT;
    s.onload = resolve;
    s.onerror = () => reject(new Error("Could not load the payment window. Check your connection."));
    document.body.appendChild(s);
  });
}

export function useRazorpayCheckout(onDone) {
  return async (student) => {
    let order;
    try {
      ({ data: order } = await api.post("/payments/order", { student_id: student.id }));
      await loadScript();
    } catch (e) {
      toast.error(errMsg(e, e.message));
      return;
    }
    const abandon = (reason, error) => api.post("/payments/abandon", { razorpay_order_id: order.order_id, reason, error }).catch(() => {});
    const rzp = new window.Razorpay({
      key: order.key_id,
      order_id: order.order_id,
      amount: order.amount,
      currency: order.currency,
      name: "Disha",
      description: `Career discovery - ${order.student_name}`,
      prefill: order.prefill,
      theme: { color: "#4F0341" },
      handler: async (resp) => {
        try {
          await api.post("/payments/verify", resp);
          toast.success("Payment confirmed. The assessment is unlocked.");
        } catch (e) {
          toast.error(errMsg(e));
        }
        onDone();
      },
      modal: { ondismiss: () => abandon("cancelled").finally(onDone) },
    });
    rzp.on("payment.failed", (r) => {
      abandon("failed", r?.error?.description);
      toast.error("Payment failed. Nothing has been charged for the assessment; you can try again.");
    });
    rzp.open();
  };
}
